import React from "react";
import styled from "styled-components";
import VoithruLogo from "src/assets/images/voithru_logo.png";
import useWindowSize from "src/utils/useWindowSize";

const Header = () => {
  const isWeb = useWindowSize();

  return (
    <>
      <HeaderContainer>
        <HeaderWrapper>
          <Link href='https://voithru.com/'>
            <Logo>
              <img
                src={VoithruLogo}
                alt="Voithru Logo"
                width={isWeb ? 110 : 75}
                height="auto"
              />
            </Logo>
          </Link>

          {isWeb && (
            <Navigation>
              <NavItem>
                <Link href='https://voithru.com/about'>회사 소개</Link>
              </NavItem>

              <NavItem>
                <Link href='https://voithru.com/video_translation'>비즈니스</Link>
                <SubMenu>
                  <SubMenuItem style={{ borderRadius: "4px 4px 0 0" }}>
                    <Link href='https://voithru.com/video_translation'>
                      번역 · 현지화
                    </Link>
                    <NestedSubMenu>
                      <NestedSubMenuItem
                        style={{ borderRadius: "4px 4px 0 0" }}
                      >
                        <Link href='https://voithru.com/video_translation'>
                          영상 번역
                        </Link>
                      </NestedSubMenuItem>
                      <NestedSubMenuItem>
                        <Link href='https://voithru.com/webtoon_webnovel_translation'>
                          웹툰 · 웹소설 번역
                        </Link>
                      </NestedSubMenuItem>
                      <NestedSubMenuItem>
                        <Link href='https://voithru.com/text_translation'>
                          문서 번역
                        </Link>
                      </NestedSubMenuItem>
                      <NestedSubMenuItem>
                        <Link href='https://voithru.com/game_translation'>
                          게임 번역
                        </Link>
                      </NestedSubMenuItem>
                      <NestedSubMenuItem>
                        <Link href='https://voithru.com/SDH'>
                          SDH 자막 제작
                        </Link>
                      </NestedSubMenuItem>
                      <NestedSubMenuItem
                        style={{ borderRadius: "0 0 4px 4px" }}
                      >
                        <Link href='https://voithru.com/post_processing'>
                          포스트 프로세싱
                        </Link>
                      </NestedSubMenuItem>
                    </NestedSubMenu>
                  </SubMenuItem>
                  <SubMenuItem style={{ borderRadius: "0 0 4px 4px" }}>
                    <Link href='https://voithru.com/TMS'>
                      기술
                    </Link>
                    <NestedSubMenu>
                      <NestedSubMenuItem
                        style={{ borderRadius: "4px 4px 0 0" }}
                      >
                        TMS
                      </NestedSubMenuItem>
                      <NestedSubMenuItem style={{ borderRadius: "0 0 4px 4px" }}>
                        <Link href='https://voithru.com/MTPE'>
                          MTPE
                        </Link>
                      </NestedSubMenuItem>
                    </NestedSubMenu>
                  </SubMenuItem>
                </SubMenu>
              </NavItem>

              <NavItem>
                <Link href='https://voithru.com/content_distribution'>
                  유통
                </Link>
              </NavItem>

              <NavItem>
                <Link href='https://voithru.com/casestudy'>
                  고객사례
                </Link>
              </NavItem>

              <NavItem>
                <Link href='https://voithru.com/Blog'>
                  블로그
                </Link>
                <SubMenu>
                  <SubMenuItem style={{ borderRadius: "4px 4px 0 0" }}>
                    <Link href='https://voithru.com/People'>
                      People
                    </Link>
                  </SubMenuItem>
                  <SubMenuItem>
                    <Link href='https://voithru.com/Tips'>
                      Tips
                    </Link>
                  </SubMenuItem>
                  <SubMenuItem>
                    <Link href='https://voithru.com/Trends'>
                      Trends
                    </Link>
                  </SubMenuItem>
                  <SubMenuItem>
                    <Link href='https://voithru.com/Service_Tech'>
                      Service & Tech
                    </Link>
                  </SubMenuItem>
                  <SubMenuItem style={{ borderRadius: "0 0 4px 4px" }}>
                    <Link href='https://voithru.com/News_PR'>
                      News & PR
                    </Link>
                  </SubMenuItem>
                </SubMenu>
              </NavItem>

              <NavItem>
                <Link href='https://voithru.com/career'>
                  채용
                </Link>
              </NavItem>
            </Navigation>
          )}
          {isWeb && (
            <RightSection>
              <Link href='https://voithru.com/quotation' style={{ height: "100%" }}>
                <QuoteButton style={{ height: "100%" }}>
                  견적 문의
                </QuoteButton>
              </Link>
            </RightSection>
          )}
        </HeaderWrapper>
      </HeaderContainer>

      {/* 모바일 네비게이션 */}
      {!isWeb && (
        <MobileNavigation>
          <MobileNavList>
            <MobileNavItem>
              <Link href='https://voithru.com/about'>
                회사 소개
              </Link>
            </MobileNavItem>
            <MobileNavItem>
              <Link href='https://voithru.com/video_translation'>
                비즈니스
              </Link>
            </MobileNavItem>
            <MobileNavItem>
              <Link href='https://voithru.com/casestudy'>
                고객사례
              </Link>
            </MobileNavItem>
            <MobileNavItem>
              <Link href='https://voithru.com/Blog'>
                블로그
              </Link>
            </MobileNavItem>
            <MobileNavItem>
              <Link href='https://voithru.com/career'>
                채용
              </Link>
            </MobileNavItem>
          </MobileNavList>
        </MobileNavigation>
      )}
    </>
  );
};

export default Header;

const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1210px;
  height: 76px;

  @media (max-width: 768px) {
    width: 100%;
    height: 48px;
    padding: 0 10px;
    justify-content: center;
  }
`;

const Logo = styled.div``;

const Link = styled.a`
  text-decoration: none;
  color: inherit;
  font-size: inherit;

  &:hover {
    cursor: pointer;
  }
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavItem = styled.div`
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  position: relative;
  padding: 10px 25px;

  &:hover {
    color: #7c4dff;
  }
`;

const SubMenu = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 160px;
  border-radius: 4px;
  z-index: 10;

  ${NavItem}:hover & {
    display: block;
  }
`;

const SubMenuItem = styled.div`
  padding: 10px 20px;
  white-space: nowrap;
  font-size: 0.9rem;
  position: relative;
  color: rgb(33, 33, 33);
  transition: all 0.3s ease;

  &:hover {
    background-color: #7c4dff;
    color: white;
  }
`;

const NestedSubMenu = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  border-radius: 4px;
  z-index: 11;

  ${SubMenuItem}:hover & {
    display: block;
  }
`;

const NestedSubMenuItem = styled.div`
  padding: 10px 20px;
  white-space: nowrap;
  font-size: 0.9rem;
  position: relative;
  color: rgb(33, 33, 33);
  transition: all 0.3s ease;

  &:hover {
    background-color: #7c4dff;
    color: white;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  align-self: stretch;
  padding: 12px 0;
`;

const QuoteButton = styled.button`
  background-color: #7c4dff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0 30px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #6a3de8;
  }
`;

// 모바일 네비게이션
const MobileNavigation = styled.div`
  width: 100%;
  background-color: rgb(126, 85, 255);
  border-top: 1px solid #f0f0f0;
`;

const MobileNavList = styled.ul`
  display: flex;
  width: 100%;
  height: 45px;
  margin: 0;
  list-style: none;
`;

const MobileNavItem = styled.li`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.55);
  text-align: center;
`;
